import api from './axiosConfig';

export interface AuditLogEntry {
    log_id: string;
    action: string;
    message: string;
    user: string;
    user_roles: string[];
    timestamp: string;
}

export interface UserActionEntry {
    log_id: string;
    action: string;
    account_number: string;
    sa_id: string;
    user: string;
    timestamp: string;
}

export interface AuditLogResponse {
    data: AuditLogEntry[];
    total: number;
    page: number;
    limit: number;
    has_next: boolean;
    has_prev: boolean;
}

export interface UserActionResponse {
    data: UserActionEntry[];
    total: number;
    page: number;
    limit: number;
    has_next: boolean;
    has_prev: boolean;
}

interface GetAuditLogsParams {
    page?: number;
    limit?: number;
    username?: string;
}

interface GetUserActionsParams {
    page?: number;
    limit?: number;
    account_number?: string;
    after_date?: string;
    before_date?: string;
}

export const auditLogService = {
    getITUserActions: async ({ page = 1, limit = 10, username }: GetAuditLogsParams = {}): Promise<AuditLogResponse> => {
        try {
            const params: any = {
                page,
                limit,
            };
            
            // Add username parameter if provided
            if (username) {
                params.username = username;
            }
            
            const response = await api.get(`/audit-log/it-user-actions`, {
                params,
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching IT user actions:', error);
            throw error;
        }
    },

    formatTimestamp: (timestamp: string): string => {
        // Create date object from UTC timestamp
        const utcDate = new Date(timestamp);
        
        // Convert to local timezone
        const localDate = new Date(utcDate.getTime() - (utcDate.getTimezoneOffset() * 60000));
        
        return localDate.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    },

    getUserActions: async ({ page = 1, limit = 10, account_number, after_date, before_date }: GetUserActionsParams = {}): Promise<UserActionResponse> => {
        try {
            const params: any = {
                page,
                limit,
            };
            
            // Add account number filter if provided
            if (account_number) {
                params.account_number = account_number;
            }
            
            // Add date filters if provided
            if (after_date) {
                params.after_date = after_date;
            }
            
            if (before_date) {
                params.before_date = before_date;
            }
            
            const response = await api.get(`/audit-log/user-actions`, {
                params,
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching user actions:', error);
            throw error;
        }
    },

    formatAction: (action: string): string => {
        return action
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }
};